import { supabase } from './supabaseClient';
import { API_URL } from './config';

// Ajoute automatiquement le jeton de session à chaque appel
export async function appelAPI(chemin, options = {}) {
  const { data: { session } } = await supabase.auth.getSession();

  const headers = { ...(options.headers || {}) };
  if (session?.access_token) {
    headers.Authorization = `Bearer ${session.access_token}`;
  }

  const reponse = await fetch(`${API_URL}${chemin}`, { ...options, headers });
  const data = await reponse.json().catch(() => ({}));

  return { ok: reponse.ok, statut: reponse.status, data };
}
// Télécharge un fichier protégé par authentification
export async function telechargerFichier(chemin, nomFichier) {
  try {
    const { data: { session } } = await supabase.auth.getSession();

    const reponse = await fetch(`${API_URL}${chemin}`, {
      headers: session?.access_token
        ? { Authorization: `Bearer ${session.access_token}` }
        : {},
    });

    if (!reponse.ok) {
      const erreur = await reponse.json().catch(() => ({}));
      return { succes: false, erreur: erreur.erreur || 'Téléchargement refusé.' };
    }

    const blob = await reponse.blob();
    const url = URL.createObjectURL(blob);
    const lien = document.createElement('a');
    lien.href = url;
    lien.download = nomFichier;
    document.body.appendChild(lien);
    lien.click();
    document.body.removeChild(lien);
    URL.revokeObjectURL(url);

    return { succes: true };
  } catch (err) {
    return { succes: false, erreur: 'Erreur réseau : ' + err.message };
  }
}